// removed by extract-text-webpack-plugin
module.exports = {"component":"upxvahFBgLWj0-PrIP_hD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Language/language.css
// module id = 1236
// module chunks = 2